import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  AddAmenityPageLoader,
  AddAmenityPageAction,
} from "./AddAmenityPage/loaders";
import {
  AmenityDetailsPageLoader,
  AmenityDetailsPageAction,
} from "./AmenityDetailsPage/loaders";
import {
  AmenityTablePageLoader,
  amenityTableShouldRevalidate,
} from "./AmenityTablePage/loaders";

const AddAmenityPage = lazyNamedPage("AddAmenityPage", () =>
  import(/* webpackChunkName: "amenity" */ "./AddAmenityPage/AddAmenityPage"),
);
const AmenityTablePage = lazyNamedPage("AmenityTablePage", () =>
  import(
    /* webpackChunkName: "amenity" */
    "./AmenityTablePage/AmenityTablePage"
  ),
);
const AmenityDetailsPage = lazyNamedPage("AmenityDetailsPage", () =>
  import(
    /* webpackChunkName: "amenity" */
    "./AmenityDetailsPage/AmenityDetailsPage"
  ),
);

export const AmenityPagesRoutes = () => {
  return (
    <>
      <Route
        path="/property/:propertyID/add-amenity"
        loader={AddAmenityPageLoader}
        action={AddAmenityPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddAmenityPage />}
      />
      <Route
        path="/amenity"
        loader={AmenityTablePageLoader}
        shouldRevalidate={amenityTableShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AmenityTablePage />}
      />
      <Route
        path={`/property/:propertyID/amenity/:amenityID`}
        loader={AmenityDetailsPageLoader}
        action={AmenityDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AmenityDetailsPage />}
      />
    </>
  );
};
